import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
const Product = lazy(() => import('./product/Product'))
const Products = lazy(() => import('./products/Products'))
const AuthenticationAppConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'auth_options',
      element: <Products />,
      children: [
        {
          path: ':id',
          element: <Product />,
        },
       
      ],
    }
  ],
}

export default AuthenticationAppConfig
